<template>
  <div :class="['nebPill', type]">
    <div>
      <span :class="{ clearable }">
        <slot></slot>
      </span>
      <span v-if="clearable">
        <neb-icon name="x"
          @click.native="$emit('clear')"
        ></neb-icon>
      </span>
    </div>
  </div>
</template>

<script>
import NebIcon from '../../Icon'

export default {
  name: 'Pill',

  components: {
    NebIcon
  },

  props: {
    type: {
      type: String,
      default: 'primary'
    },
    clearable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
@import '../../style.scss';

.nebPill {
  box-sizing: border-box;
  display: inline-block;
  padding: 5px 7px;
  border-radius: 3px;

  &.primary {
    background-color: $duck-egg-blue;
    border: solid 1px $tiffany-blue;
  }

  div {
    display: flex;
    align-items: center;

    span {
      font-family: $defaultFont;
      font-size: 12px;
      color: $slate-grey;
      line-height: normal;
      font-weight: normal;
      letter-spacing: normal;
      font-stretch: normal;
      font-style: normal;
      display: inline-block;
      white-space: nowrap;

      &.clearable {
        margin-right: 8px;
      }

      .nebIcon {
        cursor: pointer;
      }
    }
  }
}
</style>
